module.exports = __webpack_public_path__ + "/static/images/config.logo-en-US.png";